const currentYear = new Date().getFullYear();

const locale = {
    code: "en",
    label: "English",
    LANGUAGE_LABEL: "Select language",
    NAV_BAR: {
        home: "Home",
        homeId: "home",
        aboutus: "About Us",
        aboutId: "aboutus",
        faq: "FAQ",
        faqId: "faq-section",
        contact: "Contact",
        contactId: "contact-section",
        button: "Get Early Access",
    },

    HERO: {
        heroHeading: "Your Menu, Instantly Accessible",
        heroParagraph:
            "Create, update, and share your menu with a single QR code — no hassle, no reprints.",
        button: "Get Early Access",
        downloadText: "Download on the",
        appStore: "App Store",
        getItOn: "GET IT ON",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "Our Services",
        cards: [
            {
                title: "Create and Upload Menu",
                description:
                    "Easily create and upload your menu in just a few clicks! Add items, set prices, and update details effortlessly no technical skills needed.",
            },

            {
                title: "Update Menu",
                description:
                    "Make real-time updates to your menu anytime, anywhere! Change prices, add new meals or archive unavailable meals instantly no reprints needed.",
            },

            {
                title: "Generate and Share",
                description:
                    "Generate a unique QR code for your menu instantly! Share it on tables, posters, or online, allowing customers to scan and access your latest menu with ease.",
            },
        ],
    },

    FEATURES: {
        heading: "Explore Our Amazing Features",
        lists: [
            {
                title: "Manage Menu",
                description:
                    "Manage your menu anytime! Add, edit, or remove items with ease keeping your offerings fresh and up to date for your customers.",
            },

            {
                title: "Insight & Reports",
                description:
                    "Gain valuable insights with real-time reports! Track menu views, QR code scans, and customer interactions for your restaurant.",
            },

            {
                title: "Share QR Codes",
                description:
                    "Share your menu with a unique QR code! Display it on tables, posters, or online, allowing customers to scan and access your latest menu instantly.",
            },

            {
                title: "Clients Reviews",
                description:
                    "Showcase customer feedback with real reviews and ratings! Build trust, improve your menu, and enhance the dining experience with valuable insights.",
            },

            {
                title: "Offers & Discounts",
                description:
                    "Boost sales with special offers and discounts! Highlight promotions, limited-time deals, and exclusive discounts to attract and retain more customers.",
            },
        ],
    },

    ABOUT: {
        heading: "About My QR Menu",
        headingPara: "Simplify your restaurant's menu management with real-time updates.",
        highlightHeading: "Fast, Easy Access to Everything You Need",
        highlightPara: "All your menu features — just one tap away.",
        cards: {
            left: {
                heading: ["Easily add ingredients", "to your QR Menu"],
                alt: "Add Ingredients",
            },
            right: {
                heading: ["Access your menu", "dashboard easily"],
                alt: "Menu Dashboard",
            },
        },
    },

    FAQ: {
        heading: "You've got questions. We've got answers.",
        subheading: "Everything you need to know about the product.",
        items: [
            {
                question: "What is My QRMenu?",
                answer:
                    "My QRMenu is a digital menu platform that allows restaurants to create, update, and share their menus instantly using QR codes.",
            },
            {
                question: "Can I update my menu after creating it?",
                answer:
                    "Yes, you can update your menu anytime and it will reflect instantly when customers scan your QR code.",
            },
            {
                question: "How does My QRMenu work?",
                answer:
                    "You create a menu, generate a QR code, and customers can scan it to view the latest version of your menu.",
            },
            {
                question: "How do I share my QR code?",
                answer:
                    "You can share the QR code digitally or print it for display in your restaurant.",
            },
            {
                question: "Is My QRMenu mobile-friendly?",
                answer:
                    "Yes, My QRMenu is optimized for all devices, including mobile phones and tablets.",
            },
            {
                question: "Can I collect customer reviews?",
                answer:
                    "Yes, you can enable customer reviews and use the feedback to improve your offerings.",
            },
        ],
    },

    CONTACT: {
        heading: "Contact Us",
        subheading: "Our friendly team would love to hear from you.",
        firstName: "First name",
        lastName: "Last name",
        email: "Email",
        message: "Message",
        firstNamePlaceholder: "First name",
        lastNamePlaceholder: "Last name",
        emailPlaceholder: "you@company.com",
        messagePlaceholder: "Write your message...",
        privacyConsent: "You agree to our friendly",
        privacyPolicy: "privacy policy",
        submitButton: "Send Message",
        toast: {
            requiredConsent: "You must agree to the privacy policy.",
            submitting: "Submitting message...",
            success: "Message sent successfully!",
            fail: "Failed to send message. Please try again.",
            error: "An error occurred. Please check your connection.",
        },
    },

    HELP_PAGE: {
        title: "Help Center",
        description: "If you have any questions or need support, please contact us at ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "Or look through our FAQs below, you might find what you are looking for.",
    },

    FOOTER: {
        footerHeading: "Seamless Digital Menus, Simplified!",
        footerButton: "Join Waitlist",
        footerConnect: "Connect with us",
        footerTerms: "Terms & Agreements",
        footerHelp: "Help Center",
        footerPrivacy: "Privacy policy",
        footerCopyright: `©${currentYear} All rights reserved.`,
    },

    PRIVACY_POLICY: {
        title: "Privacy Policy",
        lastUpdated: "Last updated: May 22, 2025",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
                </p>
                <p class="mb-6 leading-relaxed">
                We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Privacy Policy Generator.
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">Interpretation and Definitions</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">Interpretation</h3>
                <p class="mb-6 leading-relaxed">
                    The words of which the initial letter is capitalised have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">Definitions</h3>
                <p class="mb-6 leading-relaxed">For the purposes of this Privacy Policy:</p>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
                    <li><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party.</li>
                    <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to <strong>My QR Menu,</strong> London, United Kingdom.</li>
                    <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website.</li>
                    <li><strong>Country</strong> refers to: United Kingdom</li>
                    <li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
                    <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
                    <li><strong>Service</strong> refers to the Website.</li>
                    <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company.</li>
                    <li><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself.</li>
                    <li><strong>Website</strong> refers to Myqrmenu, accessible from <a href="https://myqrmenu.co/" class="text-gray-800 underline hover:text-gray-900" target="_blank" rel="noopener noreferrer">https://myqrmenu.co/</a></li>
                    <li><strong>You</strong> means the individual accessing or using the Service.</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">Collecting and Using Your Personal Data</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-3">Types of Data Collected</h3>
                <h4 class="font-semibold mb-2">Personal Data</h4>
                <p class="mb-4 leading-relaxed">
                    While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You.
                </p>
                <ul class="list-disc list-inside mb-6 text-gray-800 space-y-2">
                    <li>Email address</li>
                    <li>First name and last name</li>
                    <li>Phone number</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">Contact Us</h2>
                <p>
                If you have any questions about this Privacy Policy, You can contact us:
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>By email: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "Terms and Conditions",
        lastUpdated: "Last updated: May 22, 2025",
        content: `
            <p class="leading-relaxed mb-6">
            Please read these Terms and Conditions carefully before using our App or Website.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. Interpretation and Definitions</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Interpretation</h3>
            <p class="leading-relaxed mb-4">
            Words with capitalized initials have specific meanings defined under the conditions below.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Definitions</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>Application</strong> means the software provided by My QR Menu.</li>
            <li><strong>Company</strong> refers to My QR Menu, based in London, UK.</li>
            <li><strong>Service</strong> refers to the Application and Website.</li>
            <li><strong>You</strong> means the individual or business accessing the Service.</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. Acknowledgment</h2>
            <p class="leading-relaxed mb-6">
            By accessing or using the Service, You agree to be bound by these Terms. If You disagree with any part, You may not access the Service.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. Links to Other Websites</h2>
            <p class="leading-relaxed mb-6">
            Our Service may contain links to third-party websites. We do not control or assume responsibility for their content or practices.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. Termination</h2>
            <p class="leading-relaxed mb-6">
            We reserve the right to terminate or suspend Your access to the Service immediately, without prior notice, for any reason.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. Limitation of Liability</h2>
            <p class="leading-relaxed mb-6">
            To the maximum extent permitted by law, the Company shall not be held liable for any damages arising from Your use of the Service.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. "AS IS" and "AS AVAILABLE" Disclaimer</h2>
            <p class="leading-relaxed mb-6">
            The Service is provided to You on an "AS IS" and "AS AVAILABLE" basis. We do not warrant that it will be error-free or uninterrupted.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. Governing Law</h2>
            <p class="leading-relaxed mb-6">
            These Terms shall be governed by the laws of the United Kingdom.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. Dispute Resolution</h2>
            <p class="leading-relaxed mb-6">
            If You have a dispute with us, You agree to attempt to resolve it informally before pursuing legal action.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. For European Union (EU) Users</h2>
            <p class="leading-relaxed mb-6">
            If You are a consumer in the EU, you are entitled to the protection of mandatory provisions of the law in your country of residence.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. United States Legal Compliance</h2>
            <p class="leading-relaxed mb-6">
            You represent and warrant that You are not located in a country subject to U.S. government sanctions.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. Severability and Waiver</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">Severability</h3>
            <p class="leading-relaxed mb-4">
            If any provision of these Terms is found unenforceable, the remaining provisions will remain in effect.
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">Waiver</h3>
            <p class="leading-relaxed mb-6">
            Failure to enforce a provision shall not constitute a waiver of such right.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. Translation Interpretation</h2>
            <p class="leading-relaxed mb-6">
            These Terms may have been translated. In case of dispute, the English version prevails.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. Changes to These Terms</h2>
            <p class="leading-relaxed mb-6">
            We may update these Terms at any time. We will notify You by posting a notice on our Website.
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. Contact Us</h2>
            <p class="leading-relaxed mb-2">If you have questions about these Terms, You can contact us:</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>By email: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
